import { createSelector } from 'reselect'

import { RequestStatus } from 'clickNgo/configs/service/common'

import { selectGeneralReportsState } from './selectGeneralReportsState'

export const selectIsGeneralReportsLoading = createSelector(
  [selectGeneralReportsState],
  ({ fetchStatus }) => fetchStatus === RequestStatus.PENDING
)
